import { createContext, useContext, useCallback } from 'react';
import useApiService from './ApiService';
import CONFIG from './CONFIG';

const ThematicApiContext = createContext(null);

export function ThematicApiProvider({ children }) {
  const { get, post, put, del } = useApiService(CONFIG.SERVER_CHANNEL);

  const getThematic = useCallback(
    async (skip, limit) => {
      if (!skip) {
        skip = 0;
      }
      if (!limit) {
        limit = 10;
      }
      try {
        const response = await get(`/v1/thematics?skip=${skip}&limit=${limit}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching thematics:', error);
        throw error;
      }
    },
    [get],
  );

  const getThematicById = useCallback(
    async (thematicId) => {
      try {
        const response = await get(`/v1/thematics/${thematicId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching thematic by ID:', error);
        throw error;
      }
    },
    [get],
  );

  const createThematic = useCallback(
    async (data) => {
      try {
        const response = await post(`/v1/thematics`, data);
        return response.data;
      } catch (error) {
        console.error('Error creating thematic:', error);
        throw error;
      }
    },
    [put],
  );

  const updateThematic = useCallback(
    async (thematicId, data) => {
      try {
        const response = await put(`/v1/thematics/${thematicId}`, data);
        return response.data;
      } catch (error) {
        console.error('Error updating thematic:', error);
        throw error;
      }
    },
    [put],
  );

  const deleteThematic = useCallback(
    async (thematicId) => {
      try {
        const response = await del(`/v1/thematics/${thematicId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting thematic:', error);
        throw error;
      }
    },
    [del],
  );

  return (
    <ThematicApiContext.Provider
      value={{
        getThematic,
        getThematicById,
        createThematic,
        updateThematic,
        deleteThematic,
      }}
    >
      {children}
    </ThematicApiContext.Provider>
  );
}

export function useThematicApi() {
  const context = useContext(ThematicApiContext);
  if (!context) {
    throw new Error('useThematicApi must be used within an ThematicApiContext');
  }
  return context;
}
